class BESSAppToggleRevisions extends BESSAppComponent {

    constructor() {
        super('.app-toggle-revisions');
    }


    setupComponent(componentNode) {
        componentNode.bindClickEvent(this, function () {

            let revisions = componentNode.parent().find('.app-revisions');
            revisions.toggleClass('visible');
            componentNode.toggleClass('expanded');

        });
    }
}